<template>
  <div v-if="showPage">
    <div class="h5_mobile" v-if="isPc">
      <scroll ref="scroll" @scrollToEnd="getData">
        <Search></Search>
        <Swiper></Swiper>
        <AreaPage></AreaPage>
        <div class="tool">
          <el-select size="medium" v-model="dataParams.categoryName" placeholder="" @change="search()">
                  <el-option
                      v-for="item in categoryArr"
                    :key="item"
                    :label="item==''?$t('other.a113'):item"
                    :value="item">
                </el-option>
            </el-select>
            <el-input size="medium" style="width:250px;" clearable v-model="dataParams.groupName" :placeholder="$t('other.a1739')"></el-input>
              <el-button style="margin-left:10px" size="medium" type="primary" @click="search()">{{$t('other.a245')}}</el-button>
        </div>
        <div class="product">{{$t('h5.DSX_index_slogn')}}</div>
        <GoodList :orderList="orderList" :showLoading="showLoading"></GoodList>
      </scroll>
    </div>
    <div v-else class="pc_home">
      <div class="tipLogin" v-if="userInfo">
        {{$t('h5.DSX_index_welcome')}}，{{userInfo.userName}}
        <span class="signout" @click="signOut()">{{$t('h5.DSX_index_signout')}}</span>
      </div>
      <div class="tipLogin" v-else>
        {{$t('h5.DSX_index_note')}}
        <span class="signout" @click="singIn()">{{$t('h5.DSX_index_log')}}</span>
      </div>
      <PcHome></PcHome>
      <PCGoodList></PCGoodList>
    </div>
  </div>
</template>

<script>
import api from "../../api/api";
import utils from "../../utils/utils";
import Search from "./components/search";
import Swiper from "./components/swiper";
import GoodList from "./components/goodlist";
import AreaPage from "./components/area";
import PcHome from "./components/PC_home";
import PCGoodList from "./components/PC_goodList";
import scroll from "./componentsbase/scroll";
import distribution from "../../api/moudles/distribution";

export default {
  data() {
    return {
      isPc: true,
      showPage: false,
      userInfo: null,
      dataParams: {
        categoryIds: [],
        name: null,
        country: null,
        offset: 10,
        page: 0,
        sortType: 0,
        userId: null,
        categoryName:'',
        groupName:''
      },
      userId: null,
      orderList: [],
      showLoading: false,
      categoryArr:[]
    };
  },
  components: {
    Search,
    Swiper,
    AreaPage,
    GoodList,
    PcHome,
    PCGoodList,
    scroll
  },
  inject: ["reload"],
  created() {
    localStorage.setItem("lang", "en");
    this.$i18n.locale = this.checked;
    this.init()

    setTimeout(() => {
      this.reload();
  ;
    },1000)
  },

  mounted() {
    this.getcate()
  },

  methods: {
  search(){
    this.dataParams.page = 0
    this.orderList = []
    this.getData()
  },
  getcate(){
        distribution.getcategory().then(res=>{
            if(res.code == 200){
                let arr = ['']
                arr.push(...res.data)
                this.categoryArr = arr
            }
        })
    },
    init() {
      this.isPc = utils.judgePcOrAndirod();
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));

      // this.dataParams.country=this.country
      let userInfo = localStorage.getItem("userInfo");
      this.userId = userInfo ? JSON.parse(userInfo).userId : null;
      this.dataParams.agencyUserId = this.userId;
      this.getDataParams();
    },

    getDataParams() {
      if (this.$route.query.invitationCode) {
        newOrders
          .getUserInviteeByCode({
            code: this.$route.query.invitationCode
          })
          .then(res => {
            if (res.code == 200) {
              this.dataParams.userId = res.data.userId;

              this.getData();
            } else {
            }
          });
      } else {
        this.getData();
      }
    },

    getData() {
      this.showPage = true;
      this.showLoading = true;
      api.getPublicStoreItem(this.dataParams).then(res => {
        if (res.code === 200) {
          console.log("ddpp", res.data);
          let list = res.data.groups;
          let falg = res.data.groups.length % 2 == 0 ? true : false;
          for (let index = 0; index < list.length; index += 2) {
            list[index].minGrossProfitRate =
              list[index].minGrossProfitRate < 0
                ? 0
                : list[index].minGrossProfitRate;
            this.orderList.push([list[index], list[index + 1]]);
          }
          if (!falg) {
            let num = this.orderList.length - 1;
            this.orderList[num].splice(1, 1);
          }

          if (this.dataParams.page < res.data.count - 1) {
            this.dataParams.page += this.dataParams.offset;
            console.log(this.dataParams.page);
          }

          console.log("orderList", this.orderList);
          this.$nextTick(() => {
            this.$refs.scroll.refresh();
          });
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    singIn() {
      this.$router.push({
        path: "/loginPage",
        query: {
          Distribution: 0
        }
      });
    },

    signOut() {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("warehouse");
      localStorage.removeItem("shopIdInfo");
      localStorage.removeItem("secondPws");
      localStorage.removeItem("storeId");
      this.$message.warning(this.$t('other.a1784'));
      this.init();
    }
  }
};
</script>
<style lang="scss" scoped>
.h5_mobile {
  background-color: #eee;

  .product {
    font-size: 23px;
    font-weight: bold;
    text-align: center;
  }
}

.pc_home {
  background-color: #eee;
  width: 1200px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  min-height: 100vh;

  .tipLogin {
    display: flex;
    justify-content: right;
    box-sizing: border-box;
    padding: 3px 15px;
    font-size: 14px;
    background-color: #fff;
    border-bottom: 1px solid #eee;
  }

  .signout {
    margin: 0 15px;
    cursor: pointer;
    color: #409eff;
  }
}
  .tool {
    display: flex;
  }
</style>